import { Input } from "@/components/ui/Input";
import InputGroup from "@/components/ui/InputGroup/InputGroup";
import Button from "@/components/ui/Button/Button";
import { BsQrCodeScan } from "react-icons/bs";
import { useQuery } from "@tanstack/react-query";
import { FrontendAssetScanApi } from "@/custolink-transpiled_by_server/bc.assets.api_methods";
import useUiContext from "@/custolink-hooks/useUiContext";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function SearchTopPart(p:{
  onClickScan: () => void
}) {
  const uic = useUiContext();
  const [query, setQuery] = useState("");
  const [debouncedInput, setDebouncedInput] = useState("");
  const {t} = useTranslation();

  // Debounce the input change
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedInput(query);
    }, 500); // 500ms debounce

    return () => clearTimeout(handler);
  }, [query]);

  const q = useQuery({
    queryFn: () =>
      FrontendAssetScanApi.assetLookup(uic._orgId, debouncedInput.trim()),
    queryKey: ["FrontendAssetScanApi", uic._orgId, debouncedInput],
    enabled : debouncedInput.trim().length > 0
  });

  useEffect(()=>{
    if(q?.data?.defaultViewResult != null){
      // Navigate to the asset landing page with the serial number
      window.location.href = `/asset/${q.data.defaultViewResult.serialnumber}`;
    } else if(q?.data?.customViewResult != null){
      window.location.href = `/view/${q.data.customViewResult.urlSlug}/${q.data.customViewResult.attrValue}`;
    }
  },[q?.data])

  const lf = uic.organisationContext.lookAndFeel

  return (
    <>
      <InputGroup>
        <Input
          className={"bg-white focus:bg-white"}
          placeholder={
            lf.i18nAssetFrontendSnoSearchbarPlaceholder != null ? t(lf.i18nAssetFrontendSnoSearchbarPlaceholder) : lf.assetFrontendSnoSearchbarPlaceholder
          }
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <Button
          icon={<BsQrCodeScan className="text-xl" />}
          onClick={p.onClickScan}
        />
      </InputGroup>
    </>
  );
}
